import React, {useRef, useContext, useEffect} from "react";
import PropTypes from "prop-types";
import { AppConfigContext } from "../context/AppConfigContextProvider";
import mapboxgl from '!mapbox-gl';

function MapboxDragnDrop(props) {
    const { sensor, mapboxLayout, latitude, longitude, setLatitude, setLongitude } = props;

    const {config} = useContext(AppConfigContext);

    const map = useRef(null);
    const mapContainer = useRef(null);

    const geojson = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
            }
          }
        ]
    };

    // Initializing the map
    useEffect(()=>{
        if (map.current){
            map.current.getSource('point').setData(geojson);
            return
        }

        let zoom = 17;

        if (latitude == 0 || longitude == 0) {
            zoom = 2;
        }

        mapboxgl.accessToken = config.mapboxKey;

        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: mapboxLayout.mapboxStyle,
            center: [longitude, latitude],
            zoom: zoom
        });

        const canvas = map.current.getCanvasContainer();

        function onMove(e) {
            const coords = e.lngLat;
      
            canvas.style.cursor = 'grabbing';
      
            geojson.features[0].geometry.coordinates = [coords.lng, coords.lat];
            map.current.getSource('point').setData(geojson);
        }
      
        function onUp(e) {
            const coords = e.lngLat;
        
            setLatitude(String(parseFloat(coords.lat).toFixed(6)));
            setLongitude(String(parseFloat(coords.lng).toFixed(6)));
            canvas.style.cursor = '';
            map.current.off('mousemove', onMove);
            map.current.off('touchmove', onMove);
        }
      
        map.current.on('load', () => {
            map.current.addSource('point', {
                type: 'geojson',
                data: geojson
            });
    
            map.current.addLayer({
                id: 'point',
                type: 'circle',
                source: 'point',
                paint: {
                'circle-radius': 10,
                'circle-color': '#F84C4C'
                }
            });
    
            map.current.on('mouseenter', 'point', () => {
                map.current.setPaintProperty('point', 'circle-color', '#3bb2d0');
                canvas.style.cursor = 'move';
            });
    
            map.current.on('mouseleave', 'point', () => {
                map.current.setPaintProperty('point', 'circle-color', '#3887be');
                canvas.style.cursor = '';
            });
    
            map.current.on('mousedown', 'point', (e) => {
                e.preventDefault();
                canvas.style.cursor = 'grab';
                map.current.on('mousemove', onMove);
                map.current.once('mouseup', onUp);
            });
    
            map.current.on('touchstart', 'point', (e) => {
                if (e.points.length !== 1) return;
                e.preventDefault();
                map.current.on('touchmove', onMove);
                map.current.once('touchend', onUp);
            });
        });

    }, [latitude, longitude])

    return <>
        <span><b>Map Preview</b></span>
        <div ref={mapContainer} className="map-container" />
        <div>
            <span><b>Tooltip:</b></span>
            <ul>
                <li>Insert Specific Latitude and Longitude Coordinates</li>
                <li>Drag and Drop The Sensor To Your Desired Location</li>
                <li>Scroll To Zoom In/Out Of The Map</li>
            </ul>
        </div>
    </>
}

MapboxDragnDrop.propTypes = {
    sensor: PropTypes.object,
    mapboxLayout: PropTypes.object,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    setLatitude: PropTypes.func,
    setLongitude: PropTypes.func,
};

export default MapboxDragnDrop;